export const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export interface Category {
  key: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    key: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20pair%20of%20modern%20athletic%20sneakers%20floating%20above%20a%20warm%20terracotta%20clay%20backdrop%2C%20dramatic%20soft%20side%20lighting%2C%20contemporary%20e-commerce%20hero%20shot%2C%20rich%20earthy%20tones%2C%20crisp%20texture%20detail%2C%20dynamic%20three-quarter%20angle%2C%20premium%20product%20photography&width=600&height=600&seq=cat-shoes&orientation=squarish&nocache=true',
  },
  {
    key: 'hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20cozy%20fleece%20hoodie%20sweatshirt%20neatly%20draped%20over%20a%20soft%20sage%20green%20pastel%20backdrop%2C%20gentle%20morning%20window%20light%2C%20minimalist%20Scandinavian%20aesthetic%2C%20relaxed%20natural%20folds%2C%20premium%20apparel%20product%20photography&width=600&height=600&seq=cat-hoodies&orientation=squarish&nocache=true',
  },
  {
    key: 'tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20crisp%20folded%20cotton%20t-shirt%20on%20a%20blush%20pink%20pastel%20background%20with%20a%20subtle%20botanical%20leaf%20shadow%2C%20airy%20soft%20diffused%20light%2C%20feminine%20minimal%20styling%2C%20premium%20e-commerce%20product%20photo%2C%20clean%20composition&width=600&height=600&seq=cat-tshirts&orientation=squarish&nocache=true',
  },
  {
    key: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20rugged%20denim%20jacket%20hung%20on%20a%20wooden%20hanger%20against%20a%20muted%20olive%20green%20wall%2C%20warm%20directional%20side%20light%2C%20editorial%20menswear%20photography%2C%20textured%20fabric%20detail%2C%20atmospheric%20styling&width=600&height=600&seq=cat-jackets&orientation=squarish&nocache=true',
  },
  {
    key: 'pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Casual%20chino%20pants%20neatly%20folded%20in%20a%20stack%20on%20a%20warm%20sandy%20beige%20surface%2C%20soft%20natural%20overhead%20light%2C%20minimal%20neutral%20palette%2C%20premium%20garment%20photography%2C%20crisp%20clean%20lines&width=600&height=600&seq=cat-pants&orientation=squarish&nocache=true',
  },
  {
    key: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20structured%20baseball%20cap%20resting%20on%20a%20warm%20amber%20orange%20gradient%20backdrop%2C%20bold%20modern%20studio%20lighting%2C%20crisp%20stitching%20detail%2C%20energetic%20product%20shot%2C%20premium%20headwear%20photography&width=600&height=600&seq=cat-headwear&orientation=squarish&nocache=true',
  },
  {
    key: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20matching%20two-piece%20tracksuit%20set%20folded%20together%20on%20a%20soft%20peach%20pastel%20background%2C%20gentle%20diffused%20light%2C%20coordinated%20minimal%20styling%2C%20premium%20apparel%20product%20photography%2C%20harmonious%20composition&width=600&height=600&seq=cat-sets&orientation=squarish&nocache=true',
  },
  {
    key: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20folded%20soft%20cotton%20undergarments%20arranged%20on%20a%20muted%20taupe%20linen%20surface%2C%20soft%20gentle%20shadows%2C%20clean%20minimal%20aesthetic%2C%20premium%20basics%20product%20photography%2C%20tidy%20orderly%20composition&width=600&height=600&seq=cat-underwear&orientation=squarish&nocache=true',
  },
  {
    key: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20vibrant%20coral%20red%20sports%20jersey%20displayed%20on%20a%20clean%20off-white%20studio%20background%2C%20energetic%20angled%20lighting%2C%20athletic%20apparel%20product%20photography%2C%20crisp%20breathable%20mesh%20detail%2C%20bold%20dynamic%20styling&width=600&height=600&seq=cat-jersey&orientation=squarish&nocache=true',
  },
  {
    key: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20curated%20flat%20lay%20of%20a%20wristwatch%2C%20sunglasses%20and%20leather%20wallet%20on%20a%20warm%20gray%20slate%20surface%2C%20soft%20overhead%20light%2C%20premium%20accessories%20product%20photography%2C%20elegant%20refined%20arrangement&width=600&height=600&seq=cat-accessories&orientation=squarish&nocache=true',
  },
  {
    key: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20structured%20leather%20tote%20bag%20on%20a%20warm%20cream%20and%20gold%20gradient%20backdrop%2C%20soft%20studio%20lighting%2C%20luxury%20accessory%20product%20photography%2C%20refined%20stitching%20detail%2C%20sophisticated%20styling&width=600&height=600&seq=cat-bags&orientation=squarish&nocache=true',
  },
  {
    key: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=A%20coiled%20cognac%20leather%20belt%20with%20a%20polished%20brass%20buckle%20on%20a%20rich%20tan%20textured%20backdrop%2C%20warm%20spotlight%2C%20premium%20leather%20goods%20product%20photography%2C%20sharp%20material%20detail&width=600&height=600&seq=cat-belts&orientation=squarish&nocache=true',
  },
  {
    key: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=An%20elegant%20amber%20glass%20perfume%20bottle%20on%20a%20soft%20rose%20pink%20pastel%20background%2C%20delicate%20warm%20light%2C%20luxury%20beauty%20product%20photography%2C%20minimalist%20refined%20styling%2C%20subtle%20reflections&width=600&height=600&seq=cat-perfumes&orientation=squarish&nocache=true',
  },
  {
    key: 'other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image:
      'https://readdy.ai/api/search-image?query=An%20eclectic%20assortment%20of%20small%20fashion%20accessories%20and%20lifestyle%20goods%20on%20a%20soft%20clay%20terracotta%20surface%2C%20warm%20diffused%20light%2C%20organized%20flat%20lay%2C%20premium%20product%20photography%2C%20rich%20textured%20arrangement&width=600&height=600&seq=cat-other&orientation=squarish&nocache=true',
  },
];